import * as yup from 'yup'

export const Schema = (branch) => {
  const { pharmacy_name, address, postcode, pharmacy_contact, telephone, pharmacy_id, pharmacy_email } = branch
  return {
    name: {
      'Branch Name': { key: pharmacy_id, defaultValue: pharmacy_name, field: 'name', validation: yup.string().required() },
    },
    address: {
      'Postcode': { key: pharmacy_id, defaultValue: postcode, field: 'address.postcode', validation: yup.string().required() },
      'Address Line 1': { key: pharmacy_id, defaultValue: address, field: 'address.addressLine1', validation: yup.string().required() },
      'City': { field: 'address.city', validation: yup.string().required() }
    },
    primaryContact: {
      'First Name': { key: pharmacy_id, defaultValue: pharmacy_contact, field: 'primaryContact.firstName', validation: yup.string().required() },
      'Last Name': { field: 'primaryContact.lastName', validation: yup.string().required() },
      'Position': { field: 'primaryContact.position', validation: yup.string().required() },
      'Email Address': { key: pharmacy_id, defaultValue: pharmacy_email, field: 'primaryContact.email', validation: yup.string().email().required() },
      'Contact Number': { key: pharmacy_id, defaultValue: telephone, field: 'primaryContact.telephone', validation: yup.string().required() }
    }
  }
}
